import { render, staticRenderFns } from "./LwfBtnFile.vue?vue&type=template&id=9cdcb5c0&scoped=true&"
import script from "./LwfBtnFile.vue?vue&type=script&lang=js&"
export * from "./LwfBtnFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cdcb5c0",
  null
  
)

export default component.exports
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QFile from 'quasar/src/components/file/QFile.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QBtn,QFile});
